import createSagaMiddleware from 'redux-saga';
import rootReducer from 'store/reducers';
import rootSaga from 'store/sagas';
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
      sagaMiddleware
    ),
});
sagaMiddleware.run(rootSaga);

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export type StoreState = ReturnType<typeof rootReducer>;

export default store;
